import { checkEqualWkt } from 'components/MapComponent/constants';
import { Feature } from 'ol';
import { boundingExtent } from 'ol/extent';
import { Geometry } from 'ol/geom';
import { Circle, Fill, Icon, Stroke, Style, Text } from 'ol/style';
import { getClusterInfoAction } from 'store/actions/searchTab';

const URL = process.env.REACT_APP_API_URL;

export const getStyle = (styleCache: any) => {
  return function (feature, resolution) {
    let size = feature.get('features').length;
    let style = styleCache[size];
    if (!style) {
      let color = size > 25 ? '192,0,0' : size > 8 ? '255,128,0' : '0,128,0';
      let radius = Math.max(8, Math.min(size * 0.75, 20));

      // Check if there's only one feature in the cluster
      if (size === 1) {
        let f = feature.get('features');
        const oked = f[0].get('oked');
        const marker = `${URL}/img/oked/${oked}.png`;

        // Use an icon for single item instead of a circle
        style = new Style({
          image: new Icon({
            src: marker,
            scale: 0.5,
          }),
        });
      } else {
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: 'rgba(' + color + ',0.5)',
              width: 10,
              lineCap: 'butt',
            }),
            fill: new Fill({
              color: 'rgba(' + color + ',1)',
            }),
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: '#fff',
            }),
          }),
        });
      }
    }
    return style;
  };
};

export const featureStyle = (feature: any) => {
  // Style for selection
  return function (feature) {
    let sel = feature.get('features');

    if (!sel) return;
    const oked = sel[0].get('oked');
    const marker = `${URL}/img/oked/${oked}.png`;

    return [
      new Style({
        image: new Icon({
          src: marker,
          scale: 0.5,
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 1,
        }),
      }),
    ];
  };
};

export const clusterClickHandler = (
  map: any,
  dispatch: any,
  layersData: any
) => {
  return (evt: any) => {
    const feature = map.forEachFeatureAtPixel(
      evt.pixel,
      (feature: Feature<Geometry>) => feature
    );

    if (!feature) {
      layersData.forEach((item) => {
        item.selectCluster.clear();
      });
      return;
    } else {
      const coord = evt.coordinate;
      const features = feature.values_.features;

      if (features.length === 1) {
        const gid = features[0].get('gid');
        dispatch(getClusterInfoAction(gid, coord));
      }
    }

    const features = feature?.values_.features;
    const index = features[0].get('index');

    const { vectorLayer } = layersData[index];
    const { selectCluster } = layersData[index];

    vectorLayer.getFeatures(evt.pixel).then((clickedFeatures) => {
      if (clickedFeatures.length) {
        // Get clustered Coordinates
        const features = clickedFeatures[0].get('features');

        const featuresWkt = features.map((item) => {
          return item.get('wkt');
        });

        const equalWkt = checkEqualWkt(featuresWkt);

        if (features.length > 1 && !equalWkt) {
          const extent = boundingExtent(
            features.map((r) => r.getGeometry().getCoordinates())
          );
          map
            .getView()
            .fit(extent, { duration: 1000, padding: [50, 50, 50, 50] });
        } else if (features.length > 1 && equalWkt) {
          if (!map.getInteractions().getArray().includes(selectCluster)) {
            map.addInteraction(selectCluster);
          }
        }
      }
    });
  };
};
